import { FC, useContext } from "react";
import { Context } from "../../index";
import { observer } from "mobx-react-lite";
import { useNavigate } from "react-router-dom";
import Confirmation from "../../component/Authorization/Confirmation/Confirmation";
import ForgotPasswordForm from "../../component/Authorization/ForgotPassword/ForgotPasswordForm";

const ForgotPassword: FC = () => {
    const { store } = useContext(Context);
    const navigate = useNavigate();

    if (!store.isAuth) {
        return (
            <div>
                <ForgotPasswordForm />
            </div>
        );
    } else if (!store.isActivate) {
        return (
            <div>
                <Confirmation />
            </div>
        );
    } else {
        navigate("/projects");
        return null;
    }
};

export default observer(ForgotPassword);
